import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import listItems from 'flarum/common/helpers/listItems';
import classList from 'flarum/common/utils/classList';
/**
 * In the discussion hero the status badges (sticky, locked, following, …)
 * sit next to the tag pills, where a bare round icon reads as a stray dot.
 * There they become pills with their label written out ("Sticky"),
 * coloured by the badge's own --badge-bg (set per type by each extension).
 */
function labelled(badge) {
  const {
    type,
    icon,
    label,
    color
  } = badge.attrs || {};
  if (!icon || !label) return badge;
  const pill = m("span", {
    className: classList('Badge', 'Badge--labelled', type && `Badge--${type}`),
    style: color ? {
      '--badge-bg': color
    } : undefined
  }, m(Icon, {
    name: icon,
    className: "Badge-icon"
  }), m("span", {
    className: "Badge-text"
  }, label));
  pill.itemName = badge.itemName;
  return pill;
}
export default function discussionBadges() {
  // DiscussionHero comes with the lazily loaded discussion page.
  extend('flarum/forum/components/DiscussionHero', 'items', function (items) {
    if (!items.has('badges')) return;
    const badges = this.attrs.discussion.badges().toArray();
    items.setContent('badges', m("ul", {
      className: "DiscussionHero-badges badges"
    }, listItems(badges.map(labelled))));
  });
}